// =====================================================
// Page loading effect
// =====================================================

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.querySelector('body').classList.remove('loading');
  }, 300);
});
